import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

/**
 * The three faces, self-hosted.
 *
 * Imported here rather than in `index.css` on purpose: that stylesheet is the one
 * place colour values are written down and `tests/test_ui_theme.py` parses it, so
 * it stays tokens-and-base-only. Bundled through `@fontsource` rather than linked
 * from Google Fonts because the SPA is served from CloudFront to a corporate
 * network — a third-party font host is a single point of failure for the whole
 * page's typography, and a request that leaves the origin for every reader.
 *
 * `wght.css`, not `standard.css`, for Archivo: the latter adds the width axis and
 * costs 90 KB of latin woff2 against 35 KB. The expanded, tracked-out feel the
 * eyebrow labels want is reachable with `letter-spacing` for free.
 *
 * Both display and body faces are variable, which is what makes them safe drop-ins:
 * Archivo covers weight 100–900 and Atkinson Hyperlegible Next 200–800, so every
 * `font-medium` (500) and `font-semibold` (600) already in this UI resolves to a
 * real weight instead of a browser-synthesised one. The static Atkinson Hyperlegible
 * ships 400 and 700 only and would have silently flattened both.
 *
 * IBM Plex Mono is static, so only the weights actually used are pulled in: 400 for
 * accessions and ids, 500 for a figure that needs to sit up.
 */
import '@fontsource-variable/archivo/wght.css'
import '@fontsource-variable/atkinson-hyperlegible-next/wght.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'

import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
